/**
 * Arquivo de entrada principal para compilação
 * Este arquivo importa todos os módulos JavaScript do tema
 */

// Importar todos os módulos
require('./mobile-menu.js');
require('./search-toggle.js');
require('./scroll-effects.js');
require('./mega-menu.js');
require('./phone-mask.js');
require('./seminovos-infinite-scroll.js');
require('./produtos-infinite-scroll.js');
require('./filtros-seminovos.js');
require('./ajax-search.js');
require('./header.js');
require('./auto-slug-generator.js');

// Espaço para importar futuros módulos
// require('./novo-modulo.js');
